import $ from 'jquery';
import api from './api';
import { trans } from 'matice';

$(() => {
    $('select[name="city_id"]').each(function () {
        const $city = $(this);
        const $district = $city.closest('form').find('select[name="district_id"]');

        const updateCities = (cities = []) => {
            $city.empty().append($('<option value="" disabled selected>' + trans('admin.fields.city') + '</option>'));
            if (cities.length) {
                cities.forEach(({ id, name }) => {
                    $city.append($(`<option value="${id}">${name}</option>`));
                });
                $city.prop('disabled', false);
            } else {
                $city.prop('disabled', true);
            }
            if ($city.data('selected')) {
                $city.val($city.data('selected'));
                $city.removeAttr('data-selected');
            }
        };

        $district
            .on('change', async function () {
                const district_id = $(this).val();
                if (district_id) {
                    const response = await api.get('cities', { params: { district_id } });
                    updateCities(response.data);
                } else {
                    updateCities([]);
                }
            })
            .trigger('change');
    });
});
